import Header from '../../../__Layout/Header';
import React , {useState} from "react";
import Loader from '../../../utils/Loader';
import { useGetCertificateListQuery } from "../../../Services/api";
import {pageUrl,pageSize} from "../../../utils/constants/constants";
export default function Index() {
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState("");
    const {
        data: getCertificateList,
        isLoading: isGetLoading,
      } = useGetCertificateListQuery({ pageUrl, params:  {search,page,pageSize}  });
      
      const getPrevious= () => {
        setPage(page-1);
        setSearch("");
      }
      const getNext=()=>{
        setPage(page+1);
        setSearch("");
      }
      const findSearch=(e)=>{
        setPage(0);
        setSearch(e.target.value);
      }
      if(isGetLoading) return  <Loader></Loader>
      return (
        <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Certificate List</h5>
                    <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                       <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">Certificate List </button>
                        </li>
                        {/* <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100" id="profile-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Certificate List Add</button>
                        </li> */}
                    </ul>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <h5 className="card-title">Certificate List</h5>
                                                <div className='row'>
                                                    <div className='col-lg-8'></div>
                                                    <div className='col-lg-4'>
                                                        <div className="datatable-search pull-right">
                                                            <input className="datatable-input" placeholder="Search..." type="search" title="Search within table" onChange={findSearch}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>#</th>
                                                                <th className='text-capitalize'>student</th>
                                                                <th className='text-capitalize'>course name</th>
                                                                <th className='text-capitalize'>certificate number</th>
                                                                <th className='text-capitalize'>total mark</th>
                                                                <th className='text-capitalize'>total percentage</th>
                                                                <th className='text-capitalize'>downlaod</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            getCertificateList?.data?.data_array?.map((item) => {
                                                                
                                                            return (
                                                                <tr key={item.result_id}>
                                                                    <th scope="row">{item.result_id}</th>
                                                                    <td>{item?.student?.first_name} {item?.student?.last_name} </td>
                                                                    <td>{item?.course?.course_name}</td>
                                                                    <td>{item.certficate_number}</td>
                                                                    <td>{item.totalmark}</td>
                                                                    <td>{item.totalpercentage}</td> 
                                                                    <td><button className="btn btn-dark">Download</button></td>                                                                                                                                       
                                                                </tr>                                            
                                                                )  
                                                            })  
                                                        } 
                                                        </tbody>
                                                </table>                        
                                                <nav aria-label="Page navigation example">
                                                    <ul className="pagination">
                                                    {getCertificateList?.data?.currentPage !==0 ? <li className="page-item"><button type="button" className="page-link" onClick={getPrevious}>Previous</button></li> :''}
                                                    <li className="page-item"> {getCertificateList?.data?.currentPage+1} </li>                                                  
                                                    <li className="page-item"> of {getCertificateList?.data?.totalPages}</li>
                                                    {getCertificateList?.data?.currentPage !==getCertificateList?.data?.totalPages ? <li className="page-item"><button type="button" className="page-link" onClick={getNext}>Next</button></li>:''}
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>  
                        </div>
                        
                    </div>
                </div>
               
            </div>

            </main>
          
        </div>
    );
}
